import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    CardWrapper,
    LogoLogin,
    PBemVindo,
    PAcessarSuaConta,
    CustomErrorMessage,
    FormContent,
    FieldGroup,
    InputFull,
    ActionsWrapper,
} from './AuthCard';
import { PrimaryTextColor } from '../../../app/theme/tokens/colors';
import { PrimaryButton, SecondaryButton } from '../../../shared/ui/Inputs';
import { LoginService } from '../../../services/auth';

const loginService = LoginService;

const safeDecodeParam = (val: string | null) => {
    if (!val) return val;
    try {
        let decoded = decodeURIComponent(val);
        if (decoded && decoded.indexOf('%') >= 0) {
            try {
                decoded = decodeURIComponent(decoded);
            } catch (e) {
                console.error('Error decoding param:', e);
            }
        }
        return decoded;
    } catch {
        return val;
    }
};

export const EmailVerifyAttributeCard: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const codeFromUrl = safeDecodeParam(searchParams.get('code') || '');

    const [code, setCode] = useState(codeFromUrl || '');
    const [messageLocal, setMessageLocal] = useState('');
    const [loading, setLoading] = useState(false);

    const handleVerify = async () => {
        if (!loginService.isLogged()) {
            setMessageLocal(
                'Você precisa fazer login para confirmar seu e-mail.\n' + 'Acesse o Portal Homecare, faça login com sua conta e tente novamente.'
            );
            return;
        }

        if (!code) {
            setMessageLocal('Informe o código de verificação recebido no seu e-mail.');
            return;
        }

        setLoading(true);
        try {
            const result = await loginService.verifyEmail(code);

            if (result && result.logged) {
                setMessageLocal('E-mail verificado com sucesso!\nVocê será redirecionado para sua página inicial.');
                setTimeout(() => navigate('/orders'), 3000);
            } else {
                const errorMsg =
                    result && (result as any).message
                        ? String((result as any).message)
                        : 'Erro ao verificar e-mail.\nSe o problema persistir, entre em contato com o suporte.';
                setMessageLocal(errorMsg);
            }
        } catch (err) {
            console.error('[emailVerifyAttribute] erro:', err);
            setMessageLocal('Erro ao verificar e-mail.\nSe o problema persistir, entre em contato com o suporte.');
        } finally {
            setLoading(false);
        }
    };

    if (!loginService.isLogged()) {
        return (
            <CardWrapper>
                <LogoLogin />

                <PBemVindo>
                    Confirmação de <b>e-mail</b>
                </PBemVindo>
                <PAcessarSuaConta>Faça login para continuar</PAcessarSuaConta>

                {messageLocal && <CustomErrorMessage style={{ whiteSpace: 'pre-line' }}>{messageLocal}</CustomErrorMessage>}

                {!messageLocal && (
                    <CustomErrorMessage style={{ whiteSpace: 'pre-line' }}>
                        Você precisa fazer login para confirmar seu e-mail.
                        {'\n'}
                        Acesse o Portal Homecare com sua conta e, em seguida, use o código recebido ou o link de confirmação.
                    </CustomErrorMessage>
                )}

                <ActionsWrapper>
                    <PrimaryButton onClick={() => navigate('/login')}>Ir para Login</PrimaryButton>
                </ActionsWrapper>
            </CardWrapper>
        );
    }

    return (
        <CardWrapper>
            <LogoLogin />

            <PBemVindo>
                Confirme seu <b>e-mail</b>
            </PBemVindo>
            <PAcessarSuaConta>Valide seus dados de acesso</PAcessarSuaConta>

            {messageLocal && <CustomErrorMessage style={{ whiteSpace: 'pre-line' }}>{messageLocal}</CustomErrorMessage>}

            <FormContent>
                <FieldGroup>
                    <label
                        style={{
                            fontSize: 14,
                            color: PrimaryTextColor,
                            textAlign: 'left',
                        }}
                    >
                        Código de verificação
                    </label>
                    <InputFull type="text" placeholder="Digite o código recebido por e-mail" value={code} onChange={(e) => setCode(e.target.value)} />
                </FieldGroup>

                <ActionsWrapper>
                    <PrimaryButton onClick={handleVerify} disabled={loading}>
                        {loading ? 'Confirmando...' : 'Confirmar e-mail'}
                    </PrimaryButton>

                    <SecondaryButton onClick={() => navigate('/orders')}>Voltar para a página inicial</SecondaryButton>
                </ActionsWrapper>
            </FormContent>
        </CardWrapper>
    );
};
